import { render, staticRenderFns } from "./PtLocks.vue?vue&type=template&id=042b5aaf&"
import script from "./PtLocks.vue?vue&type=script&lang=js&"
export * from "./PtLocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports